<template style="height:100%">
  <div class="Scale_configuration">
    <div class="left">
      <h2 style="font-size: 16px;padding:15px">量表</h2>
      <scales @sendmsg="getmsg"></scales>
    </div>

    <div class="right">
      <el-button type="primary" style="margin-left:15px;margin-top:15px;" @click="add()">新增</el-button>
      <h2 style="font-size: 16px;padding:15px">下级量表分类列表</h2>
        <el-table :data="tableData" style="width: 98%;margin-left:1%">
          <el-table-column prop="date" label="日期" width="180"></el-table-column>
          <el-table-column prop="name" label="姓名" width="180"></el-table-column>
          <el-table-column  prop="address" label="地址"></el-table-column>
          <el-table-column  prop="address" label="地址">
            <template slot-scope="scope">
              <span v-if="scope">
                修改
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination :msgToChild="msg" @send="sendmsg2"></pagination>
    </div>
  </div>
</template>
<script>
import scales from '@/components/scales.vue'
import pagination from '@/components/pagination.vue'
  export default {
    data() {
      return {
        msg:{
          pageIndex:1,
          Counts:10,
        },
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }]
      };
    },
    components:{
      scales,
      pagination
    },
    methods: {
      add(){
        this.$router.push({
          path: '/statement/Scale_configuration_add',
        })
      },
      handleClick(tab, event) {

      },
      sendmsg2(val){//量表点击时子组件传过来值
        console.log(val)
      },
      getmsg(val){//量表点击时子组件传过来值
        console.log(val)
      },
    }
  };
</script>
<style>
.Scale_configuration{width: 100%;height: 100%;}
.Scale_configuration .left{width: 350px;height: 100%;background-color: #fff;float: left;}
.Scale_configuration .right{width: calc(100% - 365px);float: right;background-color: #fff;height: 100%;}
</style>